export const FAVORITOS_UPDATED_EVENT = "favoritos-actualizados";

export function emitFavoritosActualizados() {
  window.dispatchEvent(new Event(FAVORITOS_UPDATED_EVENT));
}
